import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "react-toastify";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import "./Auth.css";
import { useAuth } from "../contexts/AuthContext";

export default function LoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    const result = await login(email, password);

    if (!result.success) {
      toast.error(result.message);
      setLoading(false);
      return;
    }

    toast.success("Login successful!");

    if (result.user.role === "admin") {
      navigate("/admin");
    } else {
      navigate("/dashboard");
    }
  };

  return (
    <div className="auth-page-wrapper">
      {/* Left side - Antibody Image */}
      <div className="auth-image-section">
        <img 
          src={`${process.env.PUBLIC_URL}/mf20.png`} 
          alt="MF20 Antibody - Myosin Heavy Chain" 
          className="antibody-image"
        />
        <div className="image-overlay"></div>
        <div className="image-label">

            <a href="https://sb3-dshb.biology.uiowa.edu/MF-20"
            target="_blank"
            rel="noopener noreferrer"
            className="label-antibody-link"
          >
            <p className="label-title">MF 20↗</p>
          </a>
          <p className="label-subtitle">Sarcomeric myosin heavy chain (MYH1E)</p>
          <div className="label-meta">
            <p className="label-depositor">Depositor: D.A Fischman (1986)</p>
          </div>
        </div>

      </div>

      {/* Right side - Login Form */}
      <div className="auth-form-section">
        <div className="auth-container">
          <div className="back-icon" onClick={() => navigate("/")}>←</div>

          <div className="auth-header">
            <div className="header-with-logo">
              <img src={`${process.env.PUBLIC_URL}/dshb-logo.png`} alt="DSHB Logo" className="header-logo" />
              <div className="header-text">
                <h1 className="portal-title">DSHB Depositor Portal</h1>
              </div>
            </div>
            <p className="portal-subtitle">Login</p>
          </div>

          <form onSubmit={handleLogin}>
            <div className="form-group">
              <label>Email Address <span className="required">*</span></label>
              <input
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                disabled={loading}
              />
            </div>

            <div className="form-group password-field">
              <label>Password <span className="required">*</span></label>
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                disabled={loading}
              />
              <span
                className="eye-icon"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>

            <button type="submit" disabled={loading}>
              {loading ? "Signing in..." : "Sign In"}
            </button>
          </form>

          <div className="forgot-link">
            <Link to="/forgot-password">Forgot your password?</Link>
          </div>

          <div className="signup-link">
            Don't have an account? <Link to="/signup">Create one here</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
